import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormModel} from '../../../common/components/form/models';
import {UrlService} from '../../../common/services/url/url.service';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {SubSink} from '@Common/core/utils/subsink';
import {UrlModel} from '../../../common/services/url/url.model';

@Component({
  selector: 'app-url-proposal',
  templateUrl: './url-proposal.component.html',
  styleUrls: ['./url-proposal.component.scss']
})
export class UrlProposalComponent implements OnInit, OnDestroy {
  @Input() form: FormModel;
  @Output() loaded: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editInPlace: EventEmitter<boolean> = new EventEmitter<boolean>();
  loading = false;
  slug: string;
  exist = false;
  subSink = new SubSink();
  constructor(public urlSvc: UrlService,
              public formSvc: FormulaireService) { }

  ngOnInit(): void {
  }

  /**
   * Enregistrement du slug
   * @param {UrlModel} url
   */
  onSlugSend(url: UrlModel) {
    const urlSlug = <UrlModel> {
      id: url.id,
      form: this.form.id,
      slug: url.slug
    };
    this.form.url_obj = [...this.form.url_obj, url];
    this.form.url_obj[0].slug = urlSlug.slug;
    this.urlSvc.patch(urlSlug).subscribe();
  }
  onEditInPlace(inEdit) {
    this.editInPlace.emit(inEdit);
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
